import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const PasswordReset = () => {
  return (
    <div>
      <PageTitle title='Password Reset' role='no show' />
      <ParaTitle paraTitle='Reset Password' />
      <Paragraph paragraph='If you forget your original password, you can reset it by using the forgot password option.' />
      <Paragraph paragraph='Click on the link "Forgot password?"' />
      <ParaImageDialog src='/tutorial_image/password-reset-1.png' />

      <Paragraph paragraph='After you click on "Forgot password?", you&#39;ll see the below page:' />
      <ParaImageDialog src='/tutorial_image/password-reset-2.png' />
      <Paragraph paragraph='Enter your username in the blank section and then click on "Send password reset link"' />
      <Paragraph paragraph='You will receive an email like the one in the image below with a link to reset password.' />
      <ParaImageDialog src='/tutorial_image/password-reset-3.png' />
      <Paragraph paragraph='When you click on the "PASSWORD RESET LINK", you&#39;ll be redirected to the two step authentication page. Enter the 6 digit code here that you received on your registered mobile number' />
      <ParaImageDialog src='/tutorial_image/password-reset-4.png' />
      <Paragraph paragraph='After you enter the 6 digit code and click on complete login, you will see the page to enter your new password.' />
      <ParaImageDialog src='/tutorial_image/password-reset-5.png' />
      <Paragraph paragraph='You can login with your username and new password.' />
      <Paragraph paragraph='Disclaimer: When you reset your password, all the draft events (events that have not been submitted yet) will be removed.' />
      
      <Pagination
        pagination={{
          prev: { name: 'Text Reports', link: '/reports/text-reports' },
          next: { name: 'Settings', link: '/settings' }
        }}
      />
    </div>
  );
};

export default PasswordReset;
